import { CartData } from '@/features/cart/shared/types/cart.types';
import { getLocaleFromPathname } from '@/shared/utils/i18n/locale-path';

export const fetchCart = async (): Promise<CartData | null> => {
  // The handler cannot read the site locale itself; outside React the pathname is the source.
  const locale = getLocaleFromPathname(window.location.pathname);
  const response = await fetch(`/api/cart?locale=${locale}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};
